import emoji from 'react-easy-emoji';

import tig from './assets/img/icons/common/tig.svg';
import swis from './assets/img/icons/common/SWIS Icon RGB.svg';
import godu from './assets/img/icons/common/godu.png';
import thomaswijnands from './assets/docs/ThomasWijnands.pdf';

export const greetings = {
    "name": "Thomas Wijnands",
    "title": "Hi all, I'm Thomas",
    "description": "A passionate Software Developer that is eager to learn it all. Therefore I can not find myself stay in 1 stack, I just love to work with a lot of diffrent things. what started for me at Infotheek Groep with the hardware, grew into building beautiful software at my first study in Haarlem. I never knew I wanted to do this work, yet when I first ever touched it, I could not let go of it",
    "resumeLink": thomaswijnands
}

export const openSource = {
};

export const contact = {

}

export const socialLinks = {
    "gitlab": "https://gitlab.com/tommie1001",
    "linkedin": "https://www.linkedin.com/in/thomas-wijnands/"
}

export const skillsSection = {
    title: 'What I feel familiar with',
    subTitle: 'Working with every stack makes me the happiest. Therefore I can not choose between them',
    skills: [
      emoji(
        '⚡ Develop fast backend systems with snappy frontends'
      ),
      emoji('⚡ Progressive Web Applications ( PWA ) '),
      emoji(
        '⚡ Hosting with third-party software such as AWS | Digital Ocean'
      ),
    ],

    softwareSkills: [

      {
        skillName: 'JavaScript',
        fontAwesomeClassname: 'logos:javascript',
      },
      {
        skillName: 'TypeScript',
        fontAwesomeClassname: 'logos:typescript-icon',
      },
      {
        skillName: 'reactjs',
        fontAwesomeClassname: 'vscode-icons:file-type-reactjs',
      }, {
        skillName: 'pwa',
        fontAwesomeClassname: 'logos:pwa',
      },
      {
        skillName: 'nodejs',
        fontAwesomeClassname: 'logos:nodejs-icon',
      },
        {
            skillName: 'vuejs',
            fontAwesomeClassname: 'logos:vue',
        },
        {
            skillName: 'yarn',
            fontAwesomeClassname: 'logos:yarn',
        },

        {
            skillName: 'npm',
            fontAwesomeClassname: 'vscode-icons:file-type-npm',
        },
        {
            skillName: 'grunt',
            fontAwesomeClassname: 'logos:grunt',
        },
        {
            skillName: 'html-5',
            fontAwesomeClassname: 'vscode-icons:file-type-html',
        },
        {
            skillName: 'css3',
            fontAwesomeClassname: 'vscode-icons:file-type-css',
        },
        {
            skillName: 'sass',
            fontAwesomeClassname: 'logos:sass',
        },
        {
            skillName: 'sass',
            fontAwesomeClassname: 'logos:less',
        },
        {
            skillName: 'Adobe',
            fontAwesomeClassname: 'ci:adobe-xd',
        },

        {
            skillName: 'php',
            fontAwesomeClassname: 'logos:php',
        },
      {
        skillName: 'laravel',
        fontAwesomeClassname: 'logos:laravel',
      }, {
        skillName: 'lumen',
        fontAwesomeClassname: 'logos:lumen',
      },
        {
        skillName: 'magento',
        fontAwesomeClassname: 'logos:magento',
      },
        {
            skillName: 'postman',
            fontAwesomeClassname: 'logos:postman-icon',
        },
        {
            skillName: 'composer',
            fontAwesomeClassname: 'logos:composer',
        },
        {
            skillName: 'mysql',
            fontAwesomeClassname: 'logos:mysql',
        },
        {
            skillName: 'flutter',
            fontAwesomeClassname: 'logos:flutter',
        }, {
            skillName: 'firebase',
            fontAwesomeClassname: 'logos:firebase',
        },
        {
            skillName: 'aws',
            fontAwesomeClassname: 'logos:aws',
        },

      {
        skillName: 'linux',
        fontAwesomeClassname: 'flat-color-icons:linux',
      },
        {
            skillName: 'ubuntu',
            fontAwesomeClassname: 'logos:ubuntu',
        },
      {
        skillName: 'git',
        fontAwesomeClassname: 'logos:git-icon',
      },
      {
        skillName: 'docker',
        fontAwesomeClassname: 'logos:docker-icon',
      },
    ],
}


export const SkillBars = [
    {
      Stack: 'Backend', //Insert stack or technology you have experience in
      progressPercentage: '90', //Insert relative proficiency in percentage
    },
    {
      Stack: 'Frontend / PWA',
      progressPercentage: '70',
    },
    {
      Stack: 'Solving problems',
      progressPercentage: '100',
    },
  ]

export const educationInfo = [
    {
      schoolName: 'Nova College Haarlem',
      subHeader: 'Software Developer MBO 4',
      duration: 'September 2017 - July 2019',
      desc: 'With this study I learned the following:',
      descBullets: [
        'Learned to create websites with php, html, css, js',
        'Discovered the working of hosting and apache2',
        'Created an all new skillset!',
      ],
    },
    {
      schoolName: 'Windesheim Almere',
      subHeader: 'Software Development HBO',
      duration: 'September 2019 - July 2021',
      desc: 'With this study I learned the following:',
      descBullets: [
        'Build web applications with diffrent frameworks and languages.',
        'Started hosting my own websites with nginx!',
        'Kept myself developing with new technologies.',
      ],
    }
]

export const experience = [
    {
        role: 'Software Developer',
        company: 'SWIS',
        companylogo: swis,
        date: 'February 2022 – Present',
        desc:
            'At the moment I am working at SWIS in Leiden, a group of 40 people wanting to make the internet better everyday. Here I work the most with Laravel and sometimes a bit of drupal. '
    },
  {
    role: 'Software Developer',
    company: 'TIG',
    companylogo: tig,
    date: 'July 2021 – February 2022',
    desc:
    'At TIG I learned a lot about Magento and React. When I had my internship here I created an PWA that is connected to Magento. Now I still keep developing myself here!'
  },
  {
    role: 'Laravel Developer',
    company: 'Godu',
    companylogo: godu,
    date: 'September 2020 – July 2021',
    desc:
    'At Godu I learned more about laravel and created new features for their webshop. It was a good experience and kept working after my internship. '
  },
  // {
  //   role: 'Software Developer Internship',
  //   company: 'Bots.io',
  //   companylogo: bots,
  //   date: 'March 2019 – July 2019',
  //   desc:
  //     'At Bots, I learned to create websites using Webflow and I created a PHP application that listens to new orders and imports them into Trello.',
  // },
]

export const projects = [
    {
    name: "Netherskate.co",
      desc:"My twin brother requested a website where he could display his own products and manage them. So I made him this site with PHP and MVC and it worked out perfectly for him.",
      link: {
          name: "View site",
          url: "https://netherskate.co/"
      }
  },{
    name: "Pictoscan.nl",
      desc:"An client called me with the question if I could create an web app where users can fill out scans and afterwards the user should be able to download their results.",
      link: {
          name: "View site",
          url: "https://www.pictoscan.nl/"
      }
  },
  {
    name: "godu.nl",
    desc:"For my internship one of the assignments where to create an site which contains all of the webshops. Like an display site for information.",
    link: {
      name: "View site",
      url: "https://www.godu.nl"
    }
  }
]

